import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: Date | string | null | undefined): string {
    if (!value) return 'NA'; // Return 'NA' if the value is null or undefined

    const date = new Date(value);

    if (this.getCurrentLanguage() === 'ar') {
      // Arabic formatting: "9ص" or "9م"
      const hour = date.getHours();
      const minute = date.getMinutes();

      // Convert to 12-hour format
      const hour12 = hour % 12 || 12;
      const period = hour >= 12 ? ' م' : ' ص'; // م for PM, ص for AM

      // Format: "9ص" or "9:30ص"
      return minute === 0 ? `${hour12}${period}` : `${hour12}:${minute.toString().padStart(2, '0')}${period}`;
    } else {
      // English formatting: "9AM" or "9:30AM"
      const hour = date.getHours();
      const minute = date.getMinutes();

      // Convert to 12-hour format
      const hour12 = hour % 12 || 12;
      const period = hour >= 12 ? ' PM' : ' AM';

      // Format: "9AM" or "9:30AM"
      return minute === 0 ? `${hour12}${period}` : `${hour12}:${minute.toString().padStart(2, '0')}${period}`;
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }
}
